import request from '@/utils/request'

//查询当前登录用户的可参加的考试
export function getLoginUserExamList(data) {
	return request({
		url: '/api/examine/getLoginUserExamList',
		method: 'get',
		params: data
	})
}
//根据id查询作业
export function getExamineById(data) {
	return request({
		url: '/api/examine/getExamineById',
		method: 'get',
		params: data
	})
}
//根据考核id查询考核的试题
export function topicByExamineId(data) {
	return request({
		url: '/api/examine/topicByExamineId',
		method: 'get',
		params: data
	})
}

//提交答案
export function answer(data) {
	return request({
		url: '/api/answer/answer',
		method: 'post',
		data
	})
}

//提交试卷
export function commit(data) {
	return request({
		url: '/api/answer/commit',
		method: 'get',
		params: data
	})
}
//初次进入考试
export function addExamRecord(data) {
	return request({
		url: '/examine/record/addExamRecord',
		method: 'post',
		data
	})
}

//根据考核记录id查看当前用户的答题情况
export function getUserAnswerList(data) {
	return request({
		url: '/api/answer/getUserAnswerList',
		method: 'get',
		params: data
	})
}
//学生根据考核id查询自己的考试详情
export function getRecordInfo(data) {
	return request({
		url: '/examine/record/getRecordInfo',
		method: 'get',
		params: data
	})
}

//添加申诉
export function addRepresentation(data) {
	return request({
		url: '/examineRepresentation/tMoocExamineRepresentationDO/addRepresentation',
		method: 'post',
		data
	})
}

//查询自己的申述
export function getMyRepresentation(data) {
	return request({
		url: '/examineRepresentation/tMoocExamineRepresentationDO/getMyRepresentation',
		method: 'get',
		params: data
	})
}
